// extracted by mini-css-extract-plugin
export default {"image":"styles_image__HasoL","icon":"styles_icon__87ysv"};